export default __webpack_public_path__ + "static/media/46.36588ac6.jpg";